
$('body').on('mouseenter', '.js-card-recipe', function() {
    let video = $(this).find('video')
    if (video.length){
      video[0].play()
    }
})

$('body').on('mouseleave', '.js-card-recipe', function() {
  let video = $(this).find('video')
  if (video.length){
    video[0].pause()
    video[0].currentTime = 0
  }
})
